module.exports = __webpack_public_path__ + "static/media/Términos y condiciones.11d12f1c.svg";